import { defineMessages } from 'react-intl';

const translations = {
  yes: {
    id: 'properties.yes',
    defaultMessage: 'Yes',
    description: 'Property translation for yes',
  },
  no: {
    id: 'properties.no',
    defaultMessage: 'No',
    description: 'Property translation for no',
  },
  fields: {
    number: {
      label: {
        id: 'properties.orderNumber',
        defaultMessage: 'Order number',
        description: 'Label of the order number field',
      },
    },
    customer: {
      label: {
        id: 'properties.customer',
        defaultMessage: 'Customer',
        description: 'Label of the customer field',
      },
    },
    organisation: {
      label: {
        id: 'properties.organisation',
        defaultMessage: 'Organisation',
        description: 'Label of the organisation field',
      },
    },
    client: {
      label: {
        id: 'properties.client',
        defaultMessage: 'Client',
        description: 'Label of the client field',
      },
    },
    isConfirmed: {
      label: {
        id: 'properties.isConfirmed',
        defaultMessage: 'Confirmed',
        description: 'Label of the is confirmed field',
      },
    },
    isAccepted: {
      label: {
        id: 'properties.isAccepted',
        defaultMessage: 'Accepted',
        description: 'Label of the is accepted field',
      },
    },
    isFinished: {
      label: {
        id: 'properties.isFinished',
        defaultMessage: 'Finished',
        description: 'Label of the is finished field',
      },
    },
    billingAddress: {
      label: {
        id: 'properties.billingAddress',
        defaultMessage: 'Billing address',
        description: 'Label of the billing address field',
      },
    },
    shippingAddress: {
      label: {
        id: 'properties.shippingAddress',
        defaultMessage: 'Shipping address',
        description: 'Label of the shipping address field',
      },
    },
  },
};

export default defineMessages(translations);
